export enum LivePollListSortBy {
  STARRED = 0,
  NAME = 1,
  TYPE = 2,
  TOTAL_PARTICIPANTS = 3,
  TOTAL_SESSIONS = 4,
  LAST_SESSION = 5,
}
